
import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
  const { isAdmin, isLoading } = useUserRole();
  
  console.log("AdminRoute: Checking admin status", { isAdmin, isLoading });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAdmin) {
    console.log("AdminRoute: Access denied - not an admin");
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
